



import React from 'react';
import ContainerLine from 'src/components/UIComponents/ContainerLine';
import { urlWebsite } from 'src/config';

import { useConfiguration } from "src/hooks/Configuration";
import { useModal } from "src/hooks/Modal";
interface Item {
    rows?: Array<Record<string, any>>,
    count?: number
}




const WorldMap = ({ data, computer, mobile }) => {

    const { configuration } = useConfiguration();
    const { addModal } = useModal();



    const openModal = (i: Record<string, any>) => {
        addModal({
            theme: 'whiteModalMedium', title: '', content: <div className="column-start gap-xs">
                <h2 style={{ fontSize: '18px' }}>{i?.title}</h2>
                <p style={{ fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: i?.description }} />
            </div>
        })
    }

    const applyOnClick = (event) => {
        // Obtenha o elemento clicado (a div)
        const rect = event.target.getBoundingClientRect();

        // Calcule a posição do clique em relação à div
        const x = event.clientX - rect.left; // Posição X dentro da div
        const y = event.clientY - rect.top;  // Posição Y dentro da div

        // Calcule a posição em porcentagem
        const left = (x / rect.width) * 100;
        const top = (y / rect.height) * 100;




        data.push({
            title: 'Origem ou destino dos produtos comercializados pelo Termasa',
            positionX: `${parseFloat(left?.toString()).toFixed(2)}`,
            positionY: `${parseFloat(top?.toString()).toFixed(2)}`,
            width: '6px',
            height: '6px',
            borderRadius: '50',
            background: 'orange'

        })
    }




    return <>
        <ContainerLine className="column"   >

            <div className="full-width column" >
                <div className="max-1400" onClick={(e) => applyOnClick(e)} style={{ width: '100%', position: 'relative' }}>

                    {data?.map(i => <div title={i?.title} onClick={() => i?.image ? false : openModal(i)} style={{ cursor: i?.image ? 'default' : 'pointer', borderRadius: `${i?.borderRadius}%`, position: 'absolute', background: i?.background, width: `${i?.width}`, height: `${i?.height}`, top: `${i?.positionY}%`, left: `${i?.positionX}%` }}>
                        {i?.image ? <img onClick={() => false} className="scaleOnHover" src={`${urlWebsite}/${i?.image}`} style={{ width: '100%', cursor: 'pointer', }} /> : <></>}


                    </div>)}


                    <img src="/apoio/mapa-clear.png" style={{ width: '100%', maxWidth: '1400px' }} />
                </div>
            </div>



        </ContainerLine>

    </>

}

export default WorldMap;